import React, { useState, useRef, useEffect, useContext } from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';
import { ShowProductPicsModal } from './Modal_ShowProductPics';
import { CreateInventoryProductModal } from './Modal_CreateInventoryProduct_retail';
import { CreateInventoryItemModal } from './Modal_CreateInventoryItem_retail';
import { ItemDetailsModal } from './Modal_Inventory_ItemDetails';
import { ReStockItemModal } from './Modal_ReStock_Item';
import { DeleteItemModal } from './Modal_Delete_Item';


import '../../../css/layout.css';


export function Tab_Management_Inventory () {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [add_to_productModal, setAdd_to_productModal] = useState(false);
    let [stockInventoryProductModal_online, setStockInventoryProductModal_online] = useState(false);
    let [stockInventoryProductModal_onSite, setStockInventoryProductModal_onSite] = useState(false);

    let [createInventoryItemModal, setCreateInventoryItemModal] = useState(false);
    let [deleteInventoryItemModal, setDeleteInventoryItemModal] = useState(false);
    let [adminPasswordCreateInventoryItemModal, setAdminPasswordCreateInventoryItemModal] = useState(false);

    let [productSalePrice, setProductSalePrice] = useState(null);

    let [productPicsModal, setProductPicsModal] = useState(false);

    let [selectedFile, seteSlectedFile] = useState(null);

    let [viewProductDetailsData, setViewProductDetailsData] = useState([]);
    let [viewProductItemsDetailsData, setViewProductItemsDetailsData] = useState([]);

    let [viewItemDetailsData, setViewItemDetailsData] = useState([]);

    let [quantityAddedToProduct, setQuantityAddedToProduct] = useState(null);
    let [quantityReplenishedStock, setQuantityReplenishedStock] = useState(null);

    let [inventoryAccessCheckboxValue, setInventoryAccessCheckboxValue] = useState(null);

    let [productID, setProductID] = useState(null);

    let [storefront, setStorefront] = useState(null);
    let [itemID, setItemID] = useState(null);
    let [itemName, setItemName] = useState(null);
    let [itemDescription, setItemDescription] = useState(null);
    let [vendorPartNum, setVendorPartNum] = useState(null);
    let [vendorName, setVendorName] = useState(null);
    let [vendorPhoneNumber, setVendorPhoneNumber] = useState(null);
    let [vendorAddress, setVendorAddress] = useState(null);
    let [vendorCity, setVendorCity] = useState(null);
    let [vendorCountry, setVendorCountry] = useState(null);
    let [costPerUnit, setCostPerUnit] = useState(null);
    let [qtyInStock, setQtyInStock] = useState(null);
    let [qtyInUse, setQtyInUse] = useState(null);
    let [dateCreated, setDateCreated] = useState(null);
    let [attachment, setAttachment] = useState(null);
    let [addedBy, setAddedBy] = useState(null);

    let [createdByEmployee, setCreatedByEmployee] = useState(null);


    let [viewInventoryProductMainDetailsData, setViewInventoryProductMainDetailsData] = useState([]);
    let [viewInventoryItemMainDetailsData, setViewInventoryItemMainDetailsData] = useState([]);

    let [searchInventoryItem, setSearchInventoryItem] = useState(null);
    let [enterAdminPassword, setEnterAdminPassword] = useState(null);
    let [showProdcutPics, setShowProductPics] = useState(false);
    let [showItemDetails, setShowItemDetails] = useState(false);
    let [activateProductButton, setActivateProductButton] = useState('inline-block');
    let [deactivateProductButton, setDeactivateProductButton] = useState('inline-block');

    let [passwordCategory, setPasswordCategory] = useState(null);
    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let [searchResults, setSearchResults] = useState([]);
    let [viewItemDetailsModal, setViewItemDetailsModal] = useState(false)
    let [viewRestockItemModal, setViewRestockItemModal] = useState(false)
    let [viewDeleteItemModal, setViewDeleteItemModal] = useState(false)

    let productItemNameRef = useRef('');
    let itemNameRef = useRef('');

    function handleEnterAdminPassword(e) {   setEnterAdminPassword(e.target.value);    }




    function updateDeleteInventoryItemModal(event) {

        if(event)
        {
            setDeleteInventoryItemModal(event);
        }
        else
        {
            setDeleteInventoryItemModal(event);
            setViewItemDetailsData([]);
        }

    }

    function handleQuantityAddedToProduct(e) {

        setQuantityAddedToProduct(e.target.value);

    }

    function handleQuantityReplenish(e) {

        setQuantityReplenishedStock(e.target.value);

    }

    function handleInventoryAccessCheckbox(checkbox) {


        if(checkbox.checked === true){
            document.getElementById("submit").removeAttribute("disabled");

            setInventoryAccessCheckboxValue("y");

        }
        else{
            document.getElementById("submit").setAttribute("disabled", "disabled");
            setInventoryAccessCheckboxValue("n");
       }
    }

    function saveUploadedFile(event) {
    
        //alert(event);
        
        if(event.target.files === null)
        {
            seteSlectedFile("/var/www/web/Public/fileServer/merchants/image-not-available.jpg")
        }
        else
        {
            seteSlectedFile(event.target.files[0]);

        }


    }


    function searchList(event)
    {
        let searchCategory = event[0];
        let searchData = event[1];

        first_searchSuppliersInDB(searchCategory, searchData);

    }

    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    {

        let formData = new FormData();
        let Tracker = '';

        //alert('Inside search Product category');
        //alert(searchCategory);
        //alert(searchData);

        /*if(searchCategory === 'name')
        {

            Tracker = '74002S_N';
        }
        else if(searchCategory === 'phone')
        {
            Tracker = '74002S_P';

        }*/

        if(searchCategory === 'stock_item')
        {

            Tracker = '74302_stock_item';
        }
        else if(searchCategory === 'delete_stock_item')
        {

            Tracker = '74304_delete_stock_item';

        }


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xInventorySearchItem: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                setSearchResults((prevSearchResults) => {
                                    return prevSearchResults.concat({
                                        db_itemId: cols[0],
                                        db_itemName: cols[1],
                                        db_itemDescription: cols[2],
                                        db_vendorPartNumber: cols[3],
                                        db_vendorName: cols[4],
                                        db_vendorPhoneNumber: cols[5],
                                        db_vendorAddress: cols[6],
                                        db_vendorCity: cols[7],
                                        db_vendorCountry: cols[8],
                                        db_costPerUnit: cols[9],
                                        db_qtyInStock: cols[10],
                                        db_qtyInUse: cols[101],
                                        db_dateCreated: cols[12],
                                        db_attachment: cols[13],

                                    })
                                });


                            
                                if(searchCategory === 'delete_stock_item')
                                {
                                    setViewItemDetailsData([]);
                    
                                    getItemDetailData(cols[0]);   
                                    document.getElementById('deleteItemGrid').style.display = 'inline-block';
                                }
                            }

                    })
        }


function getDataItemMain() {
            
    const requestOptions = {
        method: 'POST',
        //credentials: 'include',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },
        body: JSON.stringify({
            Tracker: '74401_retail',
            user: acctID,
            sessionID: sessionID,
        }),
    }

    
    fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        let rows = res.toString().split('~~~');

        for (let rownum = 0; rownum < rows.length - 1; ++rownum)
        {
            let cols = rows[rownum].split('|');


            setViewInventoryItemMainDetailsData((prevViewInventoryItemMainDetailsData) => {
                return prevViewInventoryItemMainDetailsData.concat({
                    itemID: cols[0],
                    itemName: cols[1],
                    itemDescription: cols[2],
                    vendorPartNum: cols[3],
                    vendorName: cols[4],
                    vendorPhoneNumber: cols[5],
                    vendorAddress: cols[6],
                    vendorCity: cols[7],
                    vendorCountry: cols[8],
                    costPerUnit: parseFloat(cols[9]).toFixed(2),
                    qtyInStock: cols[10],
                    qtyInUse: cols[11],
                    dateCreated: cols[12],
                    attachment: cols[13],
                    addedBy: cols[14],
                    qtyUnits: cols[15],
                })
            });

        } 
    })
}


    function getItemDetailData(itemID) {

        //alert('In getEmployeeDetailData');
        //alert(acctID);
        //alert(employeeID);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74408_retail',
                user: acctID,
                xInventoryItemID: itemID,
                sessionID: sessionID,
            }),
        }
        
        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setViewItemDetailsData((prevViewItemDetailsData) => {
                    return prevViewItemDetailsData.concat({
                        itemID: cols[0],
                        itemName: cols[1],
                        vendorPartNum: cols[2],
                        vendorName: cols[3],
                        costPerUnit: parseFloat(cols[4]).toFixed(2),
                        qtyInStock: cols[5],
                        qtyInUse: cols[6],
                        dateReplenished: cols[7],
                    })
                });
            } 
        })
    }

    function handleEnterAdminPassword(e) {   setEnterAdminPassword(e.target.value);    }




    function updateDeleteInventoryItemModal(event) {

        if(event)
        {
            setDeleteInventoryItemModal(event);
        }
        else
        {
            setDeleteInventoryItemModal(event);
            setViewItemDetailsData([]);
        }

    }

    function handleQuantityAddedToProduct(e) {

        setQuantityAddedToProduct(e.target.value);

    }

    function handleQuantityReplenish(e) {

        setQuantityReplenishedStock(e.target.value);

    }

    function handleInventoryAccessCheckbox(checkbox) {


        if(checkbox.checked === true){
            document.getElementById("submit").removeAttribute("disabled");

            setInventoryAccessCheckboxValue("y");

        }
        else{
            document.getElementById("submit").setAttribute("disabled", "disabled");
            setInventoryAccessCheckboxValue("n");
       }
    }


    function updateEnterAdminPasswordDeleteItemModal(event) {

        setAdminPasswordCreateInventoryItemModal(event);
        setDeleteInventoryItemModal(false);
    }

    function saveUploadedFile(event) {
    
        //alert(event);
        
        if(event.target.files === null)
        {
            seteSlectedFile("/var/www/web/Public/fileServer/merchants/image-not-available.jpg")
        }
        else
        {
            seteSlectedFile(event.target.files[0]);

        }


    }


function handle_add_to_product(event)
{

    // alert('In Add to Product');
    // alert(event);
    // alert(event[3]);

    setStorefront(event[1]);
    setItemID(event[2]);
    setItemName(event[3]);
    setItemDescription(event[4]);
    setVendorPartNum(event[5]);
    setVendorName(event[6]);
    setVendorPhoneNumber(event[7]);
    setVendorAddress(event[8]);
    setVendorCity(event[9]);
    setVendorCountry(event[10]);
    setCostPerUnit(event[11]);
    setQtyInStock(event[12]);
    setQtyInUse(event[13]);
    setDateCreated(event[14]);
    setAttachment(event[15]);
    setAddedBy(event[16]);
    setAdd_to_productModal(event[0]);
}

function handleSelection() {

    setViewItemDetailsData([]);

    const selectedItemName = productItemNameRef.current.value;
    const selectedItem = searchResults.find(result => result.db_itemName === selectedItemName);
  
    if (selectedItem) {
      // Execute your function here using selectedItem.db_itemId
      getItemDetailData(selectedItem.db_itemId);
    }
}


function setShowPasswordModalHandler(event)
{
    setPasswordCategory(event[1]);
    setShowPasswordModal(event[0]);

}

function handleItemDetails(event)
{
    setItemID(event[1]);
    setViewItemDetailsModal(true);
}


useEffect(() =>  {
        
        getDataItemMain();   

}, [])

//alert('In Management _ Inventory');
//alert(authenticatedMerchent_context.selectedTutorial?.tutorial_id);
//alert(authenticatedMerchent_context.selectedTutorial?.details?.step_1);
//alert(authenticatedMerchent_context.device);

        return (
            <React.Fragment>

            <IonItem>
                <IonGrid>
                    <IonRow style={{color: 'black'}}>
                        <IonCol>
                            <h3> RETAIL ITEMS </h3>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='4'>
                            {(authenticatedMerchent_context.initialSetup?.details?.step_1 == true && authenticatedMerchent_context.initialSetup?.details?.step_2 == false) || (
                            (authenticatedMerchent_context.selectedTutorial?.tutorial_id == '1' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false)
                            ) ?
                            <IonButton className='flash-tutorial' onClick={() => setCreateInventoryItemModal(true)}>Create </IonButton>
                            :<IonButton onClick={() => setCreateInventoryItemModal(true)}>Create </IonButton>}
                        </IonCol>
                        <IonCol size='4'>
                            <IonButton onClick={() => setViewRestockItemModal(true)}>Re-Stock </IonButton>
                        </IonCol>
                        <IonCol size='4'>
                            {(authenticatedMerchent_context.selectedTutorial?.tutorial_id == '4' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false)
                                ?
                            <IonButton className='flash-tutorial' onClick={() => setViewDeleteItemModal(true)}>Delete </IonButton>
                            : <IonButton onClick={() => setViewDeleteItemModal(true)}>Delete </IonButton>}
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonItem>

            <IonContent className='grid_content'>
                <IonSlides>
                    <IonSlide>
                        <IonGrid className='grid_content'>
                                <IonRow >
                                        {/*<IonCol size="1">ID</IonCol>*/}
                                        <IonCol size="4">Name</IonCol>
                                        {/*<IonCol >Vendor Part Number</IonCol>*/}
                                        {/*<IonCol >Vendor Name</IonCol>*/}
                                        {/*<IonCol >Cost per Unit</IonCol>*/}
                                        <IonCol size="3" >QtyInStock</IonCol>
                                        {/*<IonCol >Qty InUse</IonCol>*/}
                                        {/*<IonCol >Date Replenished</IonCol>*/}
                                        {/*<IonCol >Added By</IonCol>*/}
                                        <IonCol size="5">Action</IonCol>
                                </IonRow>
                                {viewInventoryItemMainDetailsData.map((detailData) =>   {
                                    return (
                                        <IonRow >
                                            {/*<IonCol size="1">{detailData.itemID}</IonCol>*/}
                                            <IonCol size="4">{detailData.itemName}</IonCol>
                                            {/*<IonCol >{detailData.vendorPartNum}</IonCol>*/}
                                            {/*<IonCol >{detailData.vendorName}</IonCol>*/}
                                            {/*<IonCol >{detailData.costPerUnit}</IonCol>*/}
                                            <IonCol size="3">{detailData.qtyInStock}{detailData.qtyUnits}</IonCol>
                                            {/*<IonCol >{detailData.qtyInUse}</IonCol>*/}
                                            {/*<IonCol >{detailData.dateReplenished}</IonCol>*/}
                                            {/*<IonCol >{detailData.addedBy}</IonCol>*/}
                                            <IonCol size="5">
                                                    <IonButton className='small_button' onClick={() => handleItemDetails([true, detailData.itemID])}>Details</IonButton>
                                               {authenticatedMerchent_context.initialSetup?.details?.step_3 == false || 
                                                (authenticatedMerchent_context.selectedTutorial?.tutorial_id == '2' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false) ||
                                                (authenticatedMerchent_context.selectedTutorial?.tutorial_id == '3' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false) 
                                                 ? <IonButton className='flash-tutorial small_button' onClick={() => handle_add_to_product([true, 'online',detailData.itemID, detailData.itemName, detailData.itemDescription, detailData.vendorPartNum, detailData.vendorName, detailData.vendorPhoneNumber, detailData.vendorAddress, detailData.vendorCity, detailData.vendorCountry, detailData.costPerUnit, detailData.qtyInStock, detailData.qtyInUse, detailData.dateCreated, detailData.attachment, detailData.createdByEmployee])}> Create Product </IonButton>
                                                 : <IonButton className='small_button' onClick={() => handle_add_to_product([true, 'online',detailData.itemID, detailData.itemName, detailData.itemDescription, detailData.vendorPartNum, detailData.vendorName, detailData.vendorPhoneNumber, detailData.vendorAddress, detailData.vendorCity, detailData.vendorCountry, detailData.costPerUnit, detailData.qtyInStock, detailData.qtyInUse, detailData.dateCreated, detailData.attachment, detailData.createdByEmployee])}> Create Product </IonButton>

                                                }
                                            
                                            </IonCol>

                                        </IonRow>
                                    )
                                }

                                
                                )}
                        </IonGrid>
                    </IonSlide>
                </IonSlides>


                {createInventoryItemModal == true && <CreateInventoryItemModal openModal={ createInventoryItemModal } closeModal={() => setCreateInventoryItemModal(false)}></CreateInventoryItemModal>}

                {add_to_productModal == true && <CreateInventoryProductModal openModal={ add_to_productModal } closeModal={() => setAdd_to_productModal(false)} data={{
                storefront: storefront,
                itemID: itemID,
                itemName: itemName,
                itemDescription: itemDescription,
                vendorPartNum: vendorPartNum,
                vendorName: vendorName,
                vendorPhoneNumber: vendorPhoneNumber,
                vendorAddress: vendorAddress,
                vendorCity: vendorCity,
                vendorCountry: vendorCountry,
                costPerUnit: costPerUnit,
                qtyInStock: qtyInStock,
                qtyInUse: qtyInUse,
                dateCreated: dateCreated,
                attachment: attachment,
                addedBy: addedBy,
                //qtyUnits: qtyUnits,
        }}></CreateInventoryProductModal>}

                {viewItemDetailsModal == true && <ItemDetailsModal openModal={ viewItemDetailsModal } closeModal={() => setViewItemDetailsModal(false)} data={{
                    itemID: itemID
                }}></ItemDetailsModal>}
                {viewRestockItemModal == true && <ReStockItemModal openModal={ viewRestockItemModal } closeModal={() => setViewRestockItemModal(false)}></ReStockItemModal>}
                {viewDeleteItemModal == true && <DeleteItemModal openModal={ viewDeleteItemModal } closeModal={() => setViewDeleteItemModal(false)}></DeleteItemModal>}


            </IonContent>
            </React.Fragment>
        )
    }   